import { render, staticRenderFns } from "./MoveStockModal.vue?vue&type=template&id=cf2d83fa&scoped=true"
import script from "./MoveStockModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveStockModal.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf2d83fa",
  null
  
)

export default component.exports